/**
 * The config fields a named preset owns.
 *
 * Mirrors the `presetDependable` flag on the stats-page cloud sync table: a field is listed here
 * when that table does NOT mark it `presetDependable: false`. The serializer that writes the
 * cloud's URL param skips exactly these fields while a named preset is active -- the preset id
 * alone reproduces them -- so a control that moves one of them has to declare that the cloud is
 * that preset no longer. Without the declaration the change serializes to nothing and the param
 * is written as null, silently losing the edit.
 *
 * Everything absent from this list (the text-processing filters, the stop levels, the black list,
 * the mask, the active word, the shuffle index) survives a named preset and needs no switch.
 */
export const PRESET_OWNED_FIELDS = Object.freeze([
  'angles',
  'background',
  'colors',
  'colorStyle',
  'fontFamily',
  'maxWords',
  'orientation',
  'rangeEnd',
  'rangeStart',
  'scaleFunction'
])

/**
 * The config fields about one question's own words: what it hides, the word it is focused on and
 * the shuffle it was laid out with. They never travel to another cloud -- the words differ there.
 */
export const QUESTION_WORDS_FIELDS = Object.freeze(['blackList', 'activeWord', 'randIndex'])

// the cloud's "custom preset" sentinel -- a string, the id comparisons are strict
export const CUSTOM_PRESET_ID = '-1'

/**
 * Tag a params bag with the custom preset when it carries a field the preset owns.
 *
 * @param {Object} params - the fields the control is handing to the cloud
 * @returns {Object} the same bag, switched to the custom preset when one of its fields is owned
 */
export const withPresetReset = params =>
  PRESET_OWNED_FIELDS.some(field => field in params) ? { ...params, currentPresetId: CUSTOM_PRESET_ID } : params
